module.exports = __webpack_public_path__ + "img/27_NACELLE_min.8a77325c.jpg";